import React from "react";
import { Chip, Typography } from "@mui/material";
import AppCustomTooltip from "../AppCustomTooltip/AppCustomTooltip";
import { MuiDataGridFontSize } from "../../../theme/App.theme";

const DataTableChipAndTooltip = ({ Data, keyName = "name"}) => {
  const dataLength = Data && (Data?.length || 0);
  return (
    <div className="d-flex gap-2 align-items-center">
      <Typography noWrap={true} className="inter-medium-300" variant="inherit">
        {Data && Data[0] ? Data[0][keyName] : "Not Available"}
      </Typography>
      {dataLength > 1 ? (
        <AppCustomTooltip
          Placement="top"
          Title={Data.map((p) => p[keyName]).join(", ")}
        >
          <Chip
            label={`+${dataLength - 1} more`}
            size="small"
            style={{ cursor: "pointer", fontSize: MuiDataGridFontSize }}
          />
        </AppCustomTooltip>
      ) : null}
    </div>
  );
};

export default DataTableChipAndTooltip;
